import { render, staticRenderFns } from "./BaseSisa.vue?vue&type=template&id=06db1087&"
import script from "./BaseSisa.vue?vue&type=script&lang=js&"
export * from "./BaseSisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports